import axiosInstance from './axios-interceptor';

// Create a new configuration
const createConfig = (dataToPost) => {
    return axiosInstance.post("/api/configs/create", dataToPost, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Get all configurations with optional filters
const getAllConfigs = (filters = {}) => {
    return axiosInstance.get("/api/configs/list", {
        params: {
            ...filters, // key
        },
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Get configuration by key
const getConfigByKey = (configKey) => {
    return axiosInstance.get(`/api/configs/${configKey}`, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Update configuration
const updateConfig = (configKey, dataToUpdate) => {
    return axiosInstance.put(`/api/configs/update/${configKey}`, dataToUpdate, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Manually refresh message cache
const refreshMessageCache = () => {
    return axiosInstance.post("/api/configs/messages/refresh", {}, {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    });
};

// Export all functions
export {
    createConfig,
    getAllConfigs,
    getConfigByKey,
    updateConfig,
    refreshMessageCache
};